import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { REQUEST_CATEGORY_OPTIONS } from '../../requests/types/request-category-options.const';
export const ALL_FILTER = 'All';
export const REQUEST_TYPE_FILTERS = [{
  name: 'All'
},
{
  name: 'Seeking',
  value: 1
},
{
  name: 'Offering',
  value: 2
}];

@Component({
  selector: 'mmb-web-app-community-filters',
  templateUrl: './community-filters.component.html',
  styleUrls: ['./community-filters.component.scss']
})
export class CommunityFiltersComponent implements OnInit {
  @Output() onFilterChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() completed: EventEmitter<any> = new EventEmitter<any>();
  @Input() isOpenedInModal: boolean;
  @Input() activeCategory: any;
  @Input() activeType: any;
  @Input() isClosedIncluded: boolean;

  ALL_FILTER = ALL_FILTER;
  REQUEST_TYPE_FILTERS = REQUEST_TYPE_FILTERS;
  menuItems: Array<any>;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.menuItems = REQUEST_CATEGORY_OPTIONS;
  }

  onClose() {
    this.activeModal.close();
  }

  onApplyFilters() {
    this.completed.emit({
      type: this.activeType ? this.activeType.value: null,
      category: this.activeCategory ? this.activeCategory.value: null,
      isClosedIncluded: this.isClosedIncluded
    });
  }

  /**
 * Request category filters (community)
 * @param item Item
 */
  onRequestCategoryClick(item) {
    this.activeCategory = item;
  }

  onRequestTypeClick(item) {
    this.activeType = item;
  }

  onReset() {
    if (this.activeCategory !== ALL_FILTER) {
      this.activeCategory = null;
    }
  }

  onIncludeClosedChanged(ev) {
    this.isClosedIncluded = !this.isClosedIncluded;
  }

}
